export default __webpack_public_path__ + "static/media/persistent_id.89a2bcd9.csv";